import aboutLogo from '../../asset/Vector 3.png'
import appLogo from '../../asset/Vector 2.png'
import contactLogo from '../../asset/Vector.png'
import { Link } from 'react-router-dom';

function Service() {
//   const [isMobile, setIsMobile] = useState(window.innerWidth > 750);

//     useEffect(() => {
//         const handleResize = () => {
//         setIsMobile(window.innerWidth > 750);
//         };

//         window.addEventListener('resize', handleResize);

//         // Cleanup listener on component unmount
//         return () => {
//         window.removeEventListener('resize', handleResize);
//         };
//     }, []);
  return (
    <>
    <div id="services" className='d-flex flex-row flex-wrap justify-content-center align-items-center gap-5 py-5 bg-white '>
            <div className='col-md-3 col-12 d-flex flex-column justify-content-center my-5 align-items-center'>
                <img src={aboutLogo} alt=""/>
                <h1 className='title py-4'>About US</h1>
                <p className='paragraph w-75 '>ANAB specializes in high-quality Ground Calcium Carbonate across various industries, delivering competitive pricing and exceptional performance for paints, plastics, agriculture, and more.</p>
                <div className='btn-style rounded-5 my-3'><Link to='/about' className='text-white text-decoration-none'>Learn More</Link></div>
            </div>
            <div className='col-md-3 col-12 d-flex flex-column justify-content-center my-3 align-items-center'>
                <img src={appLogo} alt=""/>
                <h1 className='title py-4'>Applications</h1>
                <p className='paragraph w-75 '>Explore ANAB's top-grade Ground Calcium Carbonate used across industries, enhancing products in paints, plastics, agriculture, and more with cost-effective, high-performance solutions.</p>
                <div className='btn-style rounded-5 my-3'><Link to='/applications' className='text-white text-decoration-none'>Learn More</Link></div>
            </div>
            <div className='col-md-3 col-12 d-flex flex-column justify-content-center my-3 align-items-center'>
                <img src={contactLogo} alt=""/>
                <h1 className='title py-4'>Contact Us</h1>
            <p className='paragraph w-75 '>Get in touch with us for inquiries, support, or feedback. we’re here to help you. Your thoughts are important to us, and we look forward to hearing from you!</p>
            <div className='btn-style rounded-5 my-3'><Link to='/contact' className='text-white text-decoration-none'>Learn More</Link></div>
            </div>
    </div>
    </>
  );
}

export default Service;
